var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4952 0.000608269C40.4908 5.32495 41.5316 10.5978 43.5578 15.517C45.584 20.4362 48.5558 24.905 52.3029 28.6673C56.05 32.4297 60.4987 35.4115 65.3941 37.4421C70.2895 39.4726 75.5353 40.5119 80.8309 40.5003L81.0002 40.5003C58.6067 40.5003 40.4952 58.6222 40.4952 81L40.4952 0.000608269Z",
    fill: "#E9C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4942 -5.6173e-10C40.4978 5.32366 39.4567 10.5957 37.4306 15.5142C35.4045 20.4327 32.4331 24.901 28.6868 28.6631C24.9404 32.4252 20.4926 35.4072 15.5982 37.4383C10.7037 39.4694 5.45883 40.5097 0.163887 40.4996L2.94382e-05 40.4996C22.3663 40.4996 40.5051 58.6214 40.5051 80.9992L40.4942 -5.6173e-10Z",
    fill: "#E9C0FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.6a15be55.svg";
export { ForwardRef as ReactComponent };